<template>
  <div>
      <b-row>
        <b-col cols="12">
          <b-row>
            <b-col cols="12">
              <div class="flex h-full" style="cursor: pointer;">
                <div :class="[(currentRoute === 'forms') ? 'menu-item-active' : 'menu-item']" @click="select('forms')">
                  <div class="flex mt-6">
                    <div style="font-size: 14px">Copyright Information</div>
                  </div>
                </div>
                <div :class="[(currentRoute === 'attachments') ? 'menu-item-active' : 'menu-item']" @click="select('attachments')">
                  <div class="flex mt-6">
                    <div style="font-size: 14px">Attachments</div>
                  </div>
                </div>
                <div :class="[(currentRoute === 'messages') ? 'menu-item-active' : 'menu-item']" @click="select('messages')">
                  <div class="flex mt-6">
                    <div style="font-size: 14px">Messages</div>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <CopyrightFormsDetails :application="application" v-if="currentRoute === 'forms'"/>
              <CopyrightFormFilesDetails :application="application" v-if="currentRoute === 'attachments'"/>
              <CopyrightDetailsMessages :id="application.id" v-if="currentRoute === 'messages'"/>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
  </div>
</template>

<script>
import CopyrightFormsDetails
  from "@/views/home/services/copyright/submissions/components/CopyrightFormsDetails.vue";
import CopyrightFormFilesDetails
  from "@/views/home/services/copyright/submissions/components/CopyrightFormFilesDetails.vue";
import CopyrightDetailsMessages
  from "@/views/home/services/copyright/submissions/CopyrightDetailsMessages.vue";
export default {
  name: "CopyrightPopupDetails",
  components: {
    CopyrightDetailsMessages,
    CopyrightFormFilesDetails,
    CopyrightFormsDetails
  },
  props:{
    application:Object
  },
  data(){
    return{
      currentRoute: "forms",
    }
  },
  methods:{
    select(route){
      this.currentRoute = route
    },
    reset(data){
      this.application = data
    }
  },
}
</script>

<style scoped>
th, td{
  font-size: 12px;
}
</style>
